<script setup lang="ts">
import { computed } from 'vue';

interface Props {
	size?: 'sm' | 'md' | 'lg' | 'xl';
}

const SIZES = {
	xl: '48px',
	lg: '32px',
	md: '20px',
	sm: '16px'
};

const DEFAULT_SIZE = 'md';

const props = withDefaults(defineProps<Props>(), {
	size: DEFAULT_SIZE,
});

const sizeValue = computed(() => SIZES[props.size] || DEFAULT_SIZE);
</script>

<template>
	<div class="ds-spinner-animation">
		<svg
			width="56"
			height="56"
			viewBox="0 0 56 56"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<rect
				class="ds-spinner-animation__track"
				x="3"
				y="3"
				width="50"
				height="50"
				rx="25"
				stroke-width="6"
			/>
			<path
				class="ds-spinner-animation__snake"
				d="M4.50674 36.5508C2.95033 37.1173 1.21245 36.3169 0.815599 34.7089C-0.175426 30.6933 -0.26744 26.4951 0.562107 22.4177C1.59161 17.3575 4.00037 12.6806 7.52209 8.90405C11.0438 5.12747 15.5413 2.39833 20.5173 1.01835C24.5269 -0.0935997 28.7213 -0.294665 32.7962 0.413827C34.428 0.697543 35.3477 2.37535 34.8912 3.96749V3.96749C34.4347 5.55962 32.7738 6.45833 31.1344 6.22238C28.1328 5.79039 25.0632 5.98204 22.1202 6.79819C18.2101 7.88256 14.6761 10.0271 11.9087 12.9947C9.14142 15.9623 7.24865 19.6373 6.43968 23.6135C5.83081 26.6062 5.85375 29.6818 6.49408 32.6459C6.84381 34.2648 6.06315 35.9844 4.50674 36.5508V36.5508Z"
			/>
		</svg>
	</div>
</template>

<style lang="scss" scoped>
.ds-spinner-animation {
	display: inline-block;
	margin: 0;
	vertical-align: middle;
	block-size: v-bind(sizeValue);
	inline-size: v-bind(sizeValue);

	svg {
		block-size: v-bind(sizeValue);
		inline-size: v-bind(sizeValue);
	}
}
</style>
